export default __webpack_public_path__ + "static/media/present.62933f36.svg";